import React from 'react';

import { PopupHeader } from '../popup/popupHeader';
import './infoPopup.css';

import { INFO_ICON_STATE } from '../../stateManagment';
import { TKeys, translationKeys } from '../../core/translation/translation';
import { useTranslation } from '../../core/translation/useTranslation';

export const InfoPopup = () => {
  const t = useTranslation();
  return (
    <section className="info__popup__content_root">
      <PopupHeader
        title={translationKeys.info}
        onClose={() => INFO_ICON_STATE.next(false)}
      />
      <section className="info__popup__content" dangerouslySetInnerHTML={{ __html: t(TKeys.GameInfo) }}>
      </section>
    </section>
  );
};
